export default "__VITE_ASSET__81e2f344__"